<template>
  <div class="profile-wrapper">
    <div class="form-wrapper">
      <el-form
        size="small"
        :model="form"
        status-icon
        :rules="rules"
        ref="form"
        class="demo-ruleForm"
      >
        <el-form-item label="Current Password" prop="oldPass">
          <el-input type="password" v-model="form.oldPass" autocomplete="off"
            ><i slot="prefix" class="el-input__icon el-icon-key"
          /></el-input>
        </el-form-item>
        <el-form-item label="New Password" prop="newPass">
          <el-input type="password" v-model="form.newPass" autocomplete="off"
            ><i slot="prefix" class="el-input__icon el-icon-key"
          /></el-input>
        </el-form-item>
        <el-form-item label="Confirmation" prop="confirmPass">
          <el-input
            type="password"
            v-model="form.confirmPass"
            autocomplete="off"
            ><i slot="prefix" class="el-input__icon el-icon-finished"
          /></el-input>
        </el-form-item>
        <div class="upload-wrapper">
          <!-- <el-button
            :disabled="form.signature.length === 0"
            icon="el-icon-refresh-left"
            size="mini"
            class="floating-reset"
            @click="onReset"
            >Reset</el-button
          > -->
          <el-image fit="contain" class="image-wrapper" :src="signature.image">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <input type="file" ref="signature" @change="onSignature" />
          <!-- <el-button
            size="small"
            icon="el-icon-edit"
            @click="$refs.signature.click()"
            >Signature</el-button
          > -->
        </div>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" :loading="loading.submit" @click="handleSubmit"
        >Submit Change</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CryptoJS from "crypto-js";

export default {
  name: "Profile",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.form.newPass) {
        callback(new Error("Confirm Password don't match!"));
      } else {
        callback();
      }
    };
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password"));
      } else if (
        CryptoJS.MD5(value).toString() !== this.activeUser.data.password
      ) {
        callback(new Error("Password don't match!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        oldPass: "",
        newPass: "",
        confirmPass: "",
        signature: [],
      },
      loading: {
        submit: false,
      },
      rules: {
        oldPass: [
          { required: true, validator: validateOldPass, trigger: "blur" },
        ],
        newPass: [
          {
            required: true,
            message: "Please Input Your New Password!",
            trigger: "blur",
          },
        ],
        confirmPass: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
      },
      signature: {
        image: null,
        url: process.env.VUE_APP_BACKEND + "ttd_user/",
      },
    };
  },
  created() {
    this.signature.image = this.signature.url + this.activeUser.data.ttd_user;
  },
  computed: {
    ...mapGetters({
      activeUser: "getActiveUser",
      getSSO: "getSSO"
    }),
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Home" });
    },
    onReset() {
      this.signature.image = this.signature.url + this.activeUser.data.ttd_user;
      this.form.signature = [];
    },
    onSignature(file) {
      this.form.signature = file.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file.target.files[0]);
      reader.onload = (e) => {
        this.signature.image = e.target.result;
      };
    },
    async handleSubmit() {
      const { dispatch } = this.$store;
      const token = JSON.parse(localStorage.getItem("token"));

      if(this.getSSO.access_token){
        await dispatch("getSessionSSOIsActive", {
          tlc: this.activeUser.data.tlc,
          token: this.getSSO.access_token,
        }).then(async (resSSO)=>{

          if (this.form.signature.length == 0) {
            this.$refs["form"].validate(async (valid) => {
              if (valid) {
                if (this.form.oldPass == this.form.newPass) {
                  this.$notify.error({
                    title: "Error",
                    message: "Password baru tidak boleh sama dengan password lama",
                  });
                } else {
                  await dispatch("setPasswordSSO", {
                    id: resSSO.sub, 
                    token: this.getSSO.access_token, 
                    value: this.form.newPass
                  }).then(async ()=>{
                    await dispatch("changePass", {
                      old_pass: this.form.oldPass,
                      new_pass: this.form.newPass,
                      confirm_pass: this.form.confirmPass,
                      sso_pass: this.form.confirmPass,
                      token: this.activeUser.token || token.token,
                    }).then((res) => {
                      dispatch("setActiveUser", { token: token.token });
                      this.$notify.success({
                        title: "Success",
                        message: "Your password has been changed, Please Re-Login",
                      });
                      this.$refs["form"].resetFields();
                      this.$router.push("/login");
                    });
                  }).catch((error) => {
                    let responses = Object.assign({}, error.response);
                    if(responses.status && responses.status=="403"){
                      this.$notify.error({
                        title: `Failed to Change!`,
                        message: "403: SSO Action Forbidden!",
                      });
                    }
                  });
                }
              }
            });
          } else {
            if (this.form.oldPass) {
              this.$refs["form"].validate(async (valid) => {
                if (valid) {
                  if (this.form.oldPass == this.form.newPass) {
                    this.$notify.error({
                      title: "Error",
                      message:
                        "Password baru tidak boleh sama dengan password lama",
                    });
                  } else {
                    await dispatch("setPasswordSSO", {
                      id: resSSO.sub, 
                      token: this.getSSO.access_token, 
                      value: this.form.newPass
                    }).then(async ()=>{
                      await dispatch("changeProfile", {
                        old_pass: this.form.oldPass,
                        new_pass: this.form.newPass,
                        confirm_pass: this.form.confirmPass,
                        signature: this.form.signature,
                        token: this.activeUser.token || token.token,
                      }).then((res) => {
                        dispatch("setActiveUser", { token: token.token });
                        this.$notify.success({
                          title: "Success",
                          message: "Your profile has been changed, Please Re-Login",
                        });
                        this.$refs["form"].resetFields();
                        this.$router.push("/login");
                      });
                    }).catch((error) => {
                      let responses = Object.assign({}, error.response);
                      if(responses.status && responses.status=="403"){
                      this.$notify.error({
                        title: `Failed to Change!`,
                        message: "403: SSO Action Forbidden!",
                      });
                    }
                    });
                  }
                }
              });
            } else {
              await dispatch("setPasswordSSO", {
                id: resSSO.sub, 
                token: this.getSSO.access_token, 
                value: this.form.newPass
              }).then(async ()=>{
                await dispatch("changeProfile", {
                  old_pass: this.form.oldPass,
                  new_pass: this.form.newPass,
                  confirm_pass: this.form.confirmPass,
                  signature: this.form.signature,
                  token: this.activeUser.token || token.token,
                }).then((res) => {
                  this.$notify.success({
                    title: "Success",
                    message: "Your signature has been changed!",
                  });
                  this.form.signature = [];
                  dispatch("setActiveUser", { token: token.token });
                });
              }).catch((error) => {
                let responses = Object.assign({}, error.response);
                if(responses.status && responses.status=="403"){
                  this.$notify.error({
                    title: `Failed to Change!`,
                    message: "403: SSO Action Forbidden!",
                  });
                }
              });
            }
          }
        })
      }else{
        this.$notify.error({
          title: "Error",
          message: "SSO pasword is not Changed because Session SSO is Not Found, please try again!",
        });
      }
    },
  },
  mounted() {
    Event.$emit("toggleBanner", false);
    this.signature.image = this.signature.url + this.activeUser.data.ttd_user;
  },
  destroyed() {
    Event.$emit("toggleBanner", true);
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.form-wrapper {
  margin-top: $space;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  .el {
    &-form {
      width: 400px;
    }
  }
}
.upload-wrapper {
  position: relative;
  > input {
    display: none;
  }
  > .el-button {
    width: 100%;
  }
  .image-wrapper {
    height: 100px;
    width: 100%;
    border: 1px dashed darken(white, 10);
    background-color: white;
    margin-bottom: $space / 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .floating-reset {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
    width: auto;
  }
}
.footer {
  display: flex;
  justify-content: space-around;
  margin-top: $space * 2;
  > * {
    width: 100%;
  }
}
</style>
